<template>
  <motion.div
      class="feature-card"
      :initial="{ opacity: 0, y: 30 }"
      :whileInView="{ opacity: 1, y: 0 }"
      :transition="{ delay: (index || 0) * 0.1, duration: 0.5 }"
      :inViewOptions="{ once: true }"
  >
    <div class="feature-icon">
      <img :alt="title" :src="require(`@/assets/icons/${icon}`)" />
    </div>
    <h3 class="feature-title">{{ title }}</h3>
    <p class="feature-description">{{ description }}</p>
  </motion.div>
</template>

<script lang="ts" setup>
import { motion } from "motion-v"

// eslint-disable-next-line no-undef
defineProps<{
  title: string
  description: string
  icon: string
  index?: number
}>()
</script>

<style scoped>
.feature-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  transition: transform 0.3s ease, background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  backdrop-filter: blur(6px);
  will-change: opacity, transform;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.feature-card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(0, 209, 178, 0.3);
  box-shadow: 0 10px 30px rgba(0, 209, 178, 0.1);
}

.feature-icon {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
}

.feature-icon img {
  width: 3.5rem;
  height: 3.5rem;
  display: block;
  margin: 0 auto;
  filter: brightness(0) saturate(100%) invert(79%) sepia(46%) saturate(618%) hue-rotate(100deg) brightness(92%) contrast(101%);
}

.feature-title {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.8rem;
  color: white;
}

.feature-description {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  font-size: 0.95rem;
}

@media (max-width: 768px) {
  .feature-card {
    padding: 1.5rem;
  }

  .feature-icon img {
    width: 3rem;
    height: 3rem;
  }
}
</style>